import { appendBrandNameIfPresent, PROJECT_CATCH_ERROR_LIST } from "@platformx/utilities";
import graphqlInstance from "../../config/graphqlConfig";
import {
  CREATE_SECRET,
  CREATE_TAG,
  DELETE_TAG,
  GET_SECRET,
  PUBLISH_COOKIE_SETTING,
  PUBLISH_FOOTER_SETTING,
  PUBLISH_GLOBAL_SETTING,
  PUBLISH_HEADER_SETTING,
  PUBLISH_MEDIA_HANDLE,
  PUBLISH_TAG,
  UPDATE_COOKIE_POLICY,
  UPDATE_FOOTER_SETTING,
  UPDATE_GLOBAL_SETTING,
  UPDATE_HEADER_SETTING,
  UPDATE_MEDIA_HANDLE,
} from "../../graphQL/mutations/siteSettingMutations";
import {
  FETCH_ADMIN_DOMAIN,
  FETCH_CATEGORY,
  FETCH_COOKIE_POLICY,
  FETCH_COUNTRY,
  FETCH_FOOTER_SETTING,
  FETCH_GLOBAL_SETTING,
  FETCH_HEADER_SETTING,
  FETCH_MEDIA_HANDLE,
  FETCH_MULTISITE_LISTING,
  FETCH_TAG_LISTING,
  FETCH_USER_SITE,
} from "../../graphQL/queries/siteSettingQueries";
import { ApiResponse } from "../../utils/types";

const withBrandName = (input: any): any => {
  if (!input?.input) return input;
  return { ...input, input: appendBrandNameIfPresent(input.input) };
};

export const fetchFooterSetting = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_FOOTER_SETTING,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchFooterSetting`, err);
    throw err;
  }
};

export const updateSiteSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: UPDATE_FOOTER_SETTING,
      variables: withBrandName(input),
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:updateSiteSetting`, err);
    throw err;
  }
};

export const publishFooterSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: PUBLISH_FOOTER_SETTING,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishFooterSetting`, err);
    throw err;
  }
};

export const updateHeaderSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: UPDATE_HEADER_SETTING,
      variables: withBrandName(input),
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:updateHeaderSetting`, err);
    throw err;
  }
};

export const updateGlobalSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: UPDATE_GLOBAL_SETTING,
      variables: withBrandName(input),
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:updateGlobalSetting`, err);
    throw err;
  }
};

export const fetchMediaHandle = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_MEDIA_HANDLE,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchMediaHandle`, err);
    throw err;
  }
};

export const updateMediaHanle = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: UPDATE_MEDIA_HANDLE,
      variables: withBrandName(input),
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:updateMediaHanle`, err);
    throw err;
  }
};

export const publishMediaHanle = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: PUBLISH_MEDIA_HANDLE,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishMediaHanle`, err);
    throw err;
  }
};

export const fetchCookiePolicy = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_COOKIE_POLICY,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchCookiePolicy`, err);
    throw err;
  }
};

export const mutateCookiePolicy = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: UPDATE_COOKIE_POLICY,
      variables: withBrandName(input),
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:mutateCookiePolicy`, err);
    throw err;
  }
};

export const publishCookiePolicy = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: PUBLISH_COOKIE_SETTING,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishCookiePolicy`, err);
    throw err;
  }
};

export const fetchCountries = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_COUNTRY,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchCountries`, err);
    throw err;
  }
};
export const fetchHeaderSetting = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_HEADER_SETTING,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchHeaderSetting`, err);
    throw err;
  }
};

export const fetchGlobalSetting = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_GLOBAL_SETTING,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchGlobalSetting`, err);
    throw err;
  }
};

export const fetchGlobalSettingWithHeader = async <T>(input: T, headers: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_GLOBAL_SETTING,
      variables: input,
      fetchPolicy: "no-cache",
      context: headers,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchGlobalSettingWithHeader`, err);
    throw err;
  }
};

export const publishHeaderSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: PUBLISH_HEADER_SETTING,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishHeaderSetting`, err);
    throw err;
  }
};

export const publishGlobalSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: PUBLISH_GLOBAL_SETTING,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishGlobalSetting`, err);
    throw err;
  }
};

export const fetchMultisiteListing = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_MULTISITE_LISTING,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchMultisiteListing`, err);
    throw err;
  }
};

export const fetchAdminDomainList = async <T>(): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_ADMIN_DOMAIN,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchAdminDomainList`, err);
    throw err;
  }
};

export const fetchUserSitePermissionList = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_USER_SITE,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchUserSitePermissionList`, err);
    throw err;
  }
};

export const getGlobalDataWithHeader = async (sitename: any) => {
  try {
    const { authoring_getSitedetails = {} } = await fetchGlobalSettingWithHeader(
      {
        page: "global-item",
      },
      {
        // The Apollo header link defaults `sitename` to the session-derived
        // getSelectedSite(), which during a site switch still resolves to the
        // PREVIOUS site. Flag the provided header so the target site's DAM
        // community mapping is fetched, not the old one.
        useProvidedSiteNameHeader: true,
        headers: {
          sitename: sitename,
        },
      },
    );
    const imageUuid = authoring_getSitedetails?.image?.slice(-1)?.[0]?.ScopeId;
    const videoUuid = authoring_getSitedetails?.video?.slice(-1)?.[0]?.ScopeId;
    const documentUuid = authoring_getSitedetails?.misc?.slice(-1)?.[0]?.ScopeId;

    // Write the new site's mapping, but if this site has no mapping REMOVE the
    // stale value instead of leaving the previous site's uuid behind. AUTH_INFO
    // then resolves to "" and the Asset Manager fails closed, rather than
    // showing another tenant's community.
    imageUuid ? localStorage.setItem("imageUuid", imageUuid) : localStorage.removeItem("imageUuid");
    videoUuid ? localStorage.setItem("videoUuid", videoUuid) : localStorage.removeItem("videoUuid");
    documentUuid
      ? localStorage.setItem("documentUuid", documentUuid)
      : localStorage.removeItem("documentUuid");

    localStorage.setItem("siteTheme", authoring_getSitedetails?.site_theme || "LIGHT");
    return {};
  } catch (error) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:getGlobalDataWithHeader`, error);
    return {};
  }
};

export const fetchTagListing = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_TAG_LISTING,
      variables: input,
      fetchPolicy: "network-only",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchTagListing`, err);
    throw err;
  }
};

export const fetchCategory = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.query({
    query: FETCH_CATEGORY,
    variables: input,
    fetchPolicy: "network-only",
  });
  return data;
};

export const createTag = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.mutate({
    mutation: CREATE_TAG,
    variables: input,
  });
  return data;
};

export const publishTag = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.mutate({
    mutation: PUBLISH_TAG,
    variables: input,
  });
  return data;
};

export const deleteTag = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.mutate({
    mutation: DELETE_TAG,
    variables: input,
  });
  return data;
};
export const createSecrete = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.mutate({
    mutation: CREATE_SECRET,
    variables: input,
  });
  return data;
};
export const getSecrate = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.query({
    query: GET_SECRET,
    variables: input,
    fetchPolicy: "network-only",
  });
  return data;
};

type SecretVars = { provider: string; providerType: string };
export const getSecretsMerged = async (inputs: SecretVars[]): Promise<any[]> => {
  const results = await Promise.all(
    inputs.map(async ({ provider, providerType }) => {
      const { data } = await graphqlInstance.query({
        query: GET_SECRET,
        variables: { provider, providerType },
      });
      return data?.authoring_getSecret;
    }),
  );
  return results;
};
